import { Link } from "react-router-dom";

/**
 * Post back button component
 */
export const BackButton = () => (
  <div className="back">
    <Link to="/blog">Blog</Link>
  </div>
);
